import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { State, Viewer } from "@dangl/xbim-viewer";
import {
  NbButtonModule,
  NbCardModule,
  NbDialogRef,
  NbSpinnerModule,
} from "@nebular/theme";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "ngx-three-d-model-popup",
  templateUrl: "./three-d-model-popup.component.html",
  styleUrls: ["./three-d-model-popup.component.scss"],
  imports: [NbCardModule, NbSpinnerModule, NbButtonModule],
})
export class ThreeDModelPopupComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  isLoading: boolean = true;
  xBimModelFileName: string;
  selectedXBimModelID: string;

  @ViewChild("xBimViewer", { static: true }) xBimViewer: ElementRef;
  private viewer: Viewer;
  private destroyed$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroyed$.next();
  }

  constructor(
    protected ref: NbDialogRef<any>,
    private http: HttpClient,
  ) {}

  @Input() threeDModelUrl: string;
  @Input() threeDAssetName: string;

  async ngOnInit() {}

  ngAfterViewInit(): void {
    this.openModel(this.threeDModelUrl);
  }

  openModel(modelUrl: string): void {
    if (modelUrl.length > 0) {
      this.http
        .get(modelUrl, {
          responseType: "blob",
        })
        .pipe(takeUntil(this.destroyed$))
        .subscribe((data) => this.loadXBimViewer(data));
    }
  }

  loadXBimViewer(modelData: any) {
    this.isLoading = true;
    this.viewer = new Viewer(this.xBimViewer.nativeElement);
    this.viewer.start();

    this.viewer.on("loaded", (model: { id: any }) => {
      this.selectedXBimModelID = "3D model loaded.";
      this.isLoading = false;
    });

    this.viewer.on("pick", (args: { id: any }) => {
      this.selectedXBimModelID = "Selected asset ID: " + args.id;
      const cmb = document.getElementById("cmbSelection") as any;
      const option = cmb.value;
      switch (option) {
        case "select":
          this.viewer.setState(State.HIGHLIGHTED, [args.id]);
          break;
        case "hide":
          this.viewer.setState(State.HIDDEN, [args.id]);
          break;
        default:
          break;
      }
    });

    this.viewer.on("error", (arg) => {
      this.isLoading = false;
    });

    this.selectedXBimModelID = "Loading 3D model...";

    this.viewer.load(modelData, "model");
  }

  close() {
    this.ref.close();
  }

  resetViewerState() {
    this.viewer.resetStates(true);
  }
}
